import {userService} from "@/services/user.service";

export function authHeader() {
    // return authorization header with jwt token
    let expired = localStorage.getItem('jwt_life_time');
    if (expired - new Date().getTime() > 20000) {
        return { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') };
    } else {
       // userService.logout();
        return null;
    }
}
